import React from 'react';
import {
	Datagrid, DateField,
	List, TextField,
} from 'react-admin';

export default () => (
	<List
		title="Downloadable"
		sort={{ field: 'createdAt', order: 'DESC' }}
	>
		<Datagrid rowClick="edit">
			<TextField source="id" />
			<DateField label="Создано" source="createdAt" showTime />
		</Datagrid>
	</List>
);

